module.exports = __webpack_public_path__ + "static/media/2019_conf_Great_User_Research_for_Non-Researchers.36c6a89b.png";